import { useQuery } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';

export interface FreeTrialOrganizationUsage {
  used: number;
  limit: number;
  canCreateMore: boolean;
}

/**
 * How many free-trial organizations the current user owns, against the cap.
 *
 * `staleTime: 0` on purpose. Paying for an expired organization frees a slot immediately,
 * and a user who just paid must not be told they are still at the cap — a stale answer
 * here is wrong at exactly the moment it matters most. The backend re-checks on create
 * regardless, so this is only about what the UI shows.
 */
export const useFreeTrialOrganizationUsage = (enabled = true) => {
  return useQuery<FreeTrialOrganizationUsage, Error>({
    queryKey: ['freeTrialOrganizationUsage'],
    queryFn: () => subscriptionService.getFreeTrialOrganizationUsage(),
    staleTime: 0,
    enabled,
    retry: 1,
  });
};

export default useFreeTrialOrganizationUsage;
